<template>
    <div class="position-fixed ldc-dialog"
        :style="`${fullscreen ? 'height: '+maxHeight+'px' : ''};`"
        v-show="active">
        <div :class="{
                'bg-white py-3 px-3 position-absolute ldc-dialog-content': true,
                'rounded-lg': !fullscreen
            }" v-click-outside="outside"
            :style="`width: ${fullscreen ? '100%' : width}; ${fullscreen ? 'height: '+maxHeight+'px' : ''}; ${fullscreen ? 'margin: 0 !important;' : ''}`">
            <div :class="{
                'fs-18px mb-2 title-dialog mb-2 w-100': true,
                'text-body': !colorTitle,
                'position-fixed': fullscreen && $detect == 'mobile'
            }" v-if="showTitle"
                :style="`${colorTitle ? `color: ${colorTitle};` : ''} ${fullscreen && $detect == 'mobile' ? 'top:0; left:0;' : ''}`">
                {{title}}
            </div>
            <div v-if="fullscreen && $detect == 'mobile'" :style="`height: ${heightTitle}px`"></div>
            <div class="close-modal-mobile" v-if="$detect == 'mobile' && fullscreen"
                @click="active = false">
                <i class="ionic ion-ios-arrow-back"></i>
            </div>
            <div class="close-dialog d-inline-block px-2 position-absolute"
                v-else
                @click="active = false">
                <span class="fs-10px mr-1 font-italic text-muted" style="vertical-align: 6px;"
                    v-if="$detect == 'web'">(Esc)</span>
                <i class="icon ion-ios-close"></i>
            </div>
            <div class="fs-16px main-dialog" :style="fullscreen && $detect == 'mobile' ? 'height: '+(maxHeight - heightTitle - paddingTopDialogContent)+'px; overflow-y: auto;' : ''">
                <slot/>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            default: 'Title dialog'
        },
        colorTitle: {
            type: String,
        },
        showTitle: {
            type: Boolean,
            default: true,
        },
        width: {
            type: String,
            default: '30%',
        },
        fullscreen: {
            type: Boolean,
            default: false,
        },
        visible: {
            type: Boolean,
            default: false,
        },
        clickoutside: {
            type: Boolean,
            default: true,
        },
        actionKeyBoard: {
            type: Boolean,
            default: true,
        },
        awaitKeyboard: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            active: false,
            heightTitle: 0,
            maxHeight: 0,
            marginTopTitle: 0,
            marginBottomTitle: 0,
            paddingTopDialogContent: 0,
        }
    },
    watch: {
        visible(val){
            this.active = val;
        },
        active(val){
            this.$emit('update:visible', val);
            if(val){
                this.setHeight();
                this.$overflowHidenBody();
                if(this.$detect == 'web' && this.actionKeyBoard){
                    window.addEventListener('keydown', this.keyCodeGlobal);
                }
            }else{
                this.$removeOverflowHidenBody();
                if(this.$detect == 'web' && this.actionKeyBoard){
                    window.removeEventListener('keydown', this.keyCodeGlobal);
                }
            }
        },
    },
    mounted() {
        if(window.visualViewport){
            visualViewport.addEventListener('resize', this.resize);
        }
        
    },
    beforeDestroy(){
        if(window.visualViewport){
            visualViewport.removeEventListener('resize', this.resize);
        }
    },
    methods: {
        keyCodeGlobal(e){
            if(this.awaitKeyboard) return;
            if(e.keyCode == 27){
                // Escape
                this.active = false;
            }
        },
        resize(){
            if(this.active && this.$detect == 'mobile' && this.fullscreen){
                this.setHeight();
            }
        },
        outside(e){
            if(this.clickoutside && this.$el === e.target){
                this.active = false;
            }
        },
        setHeight(timeOut = 1){
            setTimeout(()=>{
                let title = this.$el.querySelector('.title-dialog'); // lấy tiêu đề
                let ldcDialogContent = this.$el.querySelector('.ldc-dialog-content');
                this.paddingTopDialogContent = ldcDialogContent ? window.getComputedStyle(ldcDialogContent).getPropertyValue('padding-top').match(/\d+/)[0]*1 : 0;
                this.marginTopTitle = title ? window.getComputedStyle(title).getPropertyValue('margin-top').match(/\d+/)[0]*1 : 0;
                this.marginBottomTitle = title ? window.getComputedStyle(title).getPropertyValue('margin-bottom').match(/\d+/)[0]*1 : 0;
                this.heightTitle = title ? title.offsetHeight - this.paddingTopDialogContent + this.marginBottomTitle : 0;
                if(this.$detect == 'mobile' && this.fullscreen){
                    this.maxHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
                }
            }, timeOut)
            
        }
    
    }
}
</script>